import axios from "@/api/axiosInstance";
import { FetchSessionsReportParams } from "./types";

export const fetchSessionsReportCsv = async (
  params: Omit<FetchSessionsReportParams, "page" | "pageSize"> = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/reports/sessions/export",
    { responseType: "blob", params },
  );
  return response.data;
};
